<template>
  <div class="timeslot-collection">
    <CollapseGroup
      :title="isBlockerTSC ? 'Blocked timeslots this week' : 'Exceptions this week'"
      :init-collapse="true">
      <!-- TODO SORT BY DATE -->

      <el-checkbox size="small" v-model="show_inactive_items">Show inactive items</el-checkbox>

      <el-row
        v-for="exception in exception_list_sorted"
        v-if="show_inactive_items || !pruned_exceptions.includes( exception.$id )"
        :key="'exp-'+exception.$id">
        <!-- {{exception.type}} -->

        <span :style="{
          textDecoration: pruned_exceptions.includes( exception.$id ) ? 'line-through' : 'none',
          fontSize: '11pt'
          }">
          <template v-if="exception.type === 'DEL'">
            <font-awesome-icon icon="minus-square" />
            Del. timeslot on {{exception.date|shortDate}}
            <span v-if="SHOW_DEBUG" style="font-size: 8pt">(Rule: {{exception.ref}})</span>
            <a href="#" @click.prevent="onUndoException(exception.$id)"><font-awesome-icon icon="trash" /></a>
          </template>

          <template v-if="exception.type === 'INS'">
            <font-awesome-icon icon="plus-square" />
            Ins. timeslot on {{exception.from|shortDate}}
            <strong>from</strong> {{exception.from|shortTime}}
            <strong>to</strong> {{exception.to|shortTime}}
            <a href="#" @click.prevent="onUndoException(exception.$id)"><font-awesome-icon icon="trash" /></a>
          </template>

          <template v-if="exception.type === 'CHG'">
            <font-awesome-icon icon="pen-square" />
            <!-- {{exception.date|shortDate}} -->
            Changed timeslot on {{exception.new_from|shortDate}}
            <strong>from</strong> {{exception.new_from|shortTime}}
            <strong>to</strong> {{exception.new_to|shortTime}}
            <span v-if="SHOW_DEBUG" style="font-size: 8pt">(Rule: {{exception.ref}})</span>
            <a href="#" @click.prevent="onUndoException(exception.$id)"><font-awesome-icon icon="trash" /></a>
          </template>
        </span>

      </el-row>
    </CollapseGroup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CollapseGroup from '@/components/Elements/CollapseGroup';

export default {
  props: {
    timeslot_collection_id: {
      type: String,
      default: ""
    },
    isBlockerTSC: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    show_inactive_items: false,
  }),
  mounted() {
  },
  computed: {
    ...mapGetters('timeslots', [
      'flattened_calendar_data_all',
    ]),

    exception_list_sorted() {
      /*
      let list = this.$models.timeslotException
        .with({ timeslotCollectionId: this.timeslot_collection_id })
        .getList()
      return list ? list.itemsAsArray() : []
      */

      // TODO: Can be optimized (first filter, then sort)
      let list = this.$models.timeslotException.getList().itemsSorted
      return list.filter(exception => exception.tscId === this.timeslot_collection_id )
    },

    pruned_exceptions() {
      let flattened_calendar_data = this.flattened_calendar_data_all[this.timeslot_collection_id];
      return flattened_calendar_data.pruned_exceptions || [];
    },
  },
  methods: {
    onUndoException( id ) {
      console.log("onUndoException", id);
      this.$api.timeslot_collection_rem_exception({
        timeslotCollectionId: this.timeslot_collection_id,
        exceptionId: id
      })
    },
  },
  components: {
    CollapseGroup,
  }
}
</script>

<style>
</style>
